import React from 'react';
import Typography from '@bexs/dollar/components/Typography';
import FlexBox from '@bexs/dollar/components/Flex';

import Summary from './sections/Summary';
import ResultList from './sections/ResultList';

const Balance: React.FC = () => {
  return (
    <>
      <FlexBox justifyContent="space-between" alignItems="center">
        <Typography as="h5" weight="400" plain size="24px">
          Balance
        </Typography>
      </FlexBox>
      <Summary />
      <ResultList />
    </>
  );
};

export default Balance;
